// @flow
import type { FidBadgesType, FidModalesType, FidOffresType } from 'types/Fid';
import { nullFidBadges, nullFidModales, nullFidOffres } from 'types/Fid';
import { mergeIntoDefault } from 'utils/objectUtils';

export function convertFidBadgesFromApi(rawFidBadges: FidBadgesType): FidBadgesType {
  if (!rawFidBadges) {
    return nullFidBadges;
  }

  return mergeIntoDefault(nullFidBadges, {
    ...rawFidBadges
  });
}

export function convertFidModalesFromApi(rawFidModales: FidModalesType): FidModalesType {
  if (!rawFidModales) {
    return nullFidModales;
  }

  return mergeIntoDefault(nullFidModales, {
    ...rawFidModales
  });
}

export function convertFidOffresFromApi(rawFidOffres: FidOffresType): FidOffresType {
  if (!rawFidOffres) {
    return nullFidOffres;
  }

  return mergeIntoDefault(nullFidOffres, {
    ...rawFidOffres
  });
}
